module.exports = __webpack_public_path__ + "static/media/checked_patient.bae5bc7c.svg";